import { Input } from "@heroui/input";
import { Button } from "@heroui/button";
import { Link } from "@heroui/link";
import { useEffect } from "react";
import { Divider } from "@heroui/divider";
import { Card, Image } from "@heroui/react";
import Autoplay from "embla-carousel-autoplay";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import cover1 from "/public/SilaAnimal1.jpg";
import cover3 from "/public/SilaAnimal2.jpg";
import cover4 from "/public/SilaAnimal3.jpg";
import cover5 from "/public/SilaAnimal4.jpg";
import cover6 from "/public/SilaAnimal5.jpg";
// import usePersist from "@/hooks/usePersist.ts";
import { useLogin } from "@/features/Auth/AuthApi.ts";
import { AuthStore } from "@/store/useAuthStore.ts";
import { loginSchema, TLoginSchema } from "@/models/Authentication.Schema.ts";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { toast } from "sonner";
import { zodResolver } from "@hookform/resolvers/zod";
import { TailSpin } from "react-loader-spinner";

export default function AuthPage() {
  // const [isVisible, setIsVisible] = useState(false);
  // const [persist, setPersist] = usePersist();
  const { mutateAsync, isPending } = useLogin();
  const navigate = useNavigate();
  const { userInfo } = AuthStore();

  const form = useForm<TLoginSchema>({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  // const handleToggle = () => setPersist((prev: unknown) => !prev);

  const onSubmit = async (Data: TLoginSchema) => {
    toast.promise(mutateAsync(Data), {
      loading: "Logging User...",
      success: () => {
        return "Logged In Successfully";
      },
      error: (error: any) => {
        form.resetField("password");
        return (
          error?.response?.data?.message || "Login failed. Please try again."
        );
      },
      position: "top-right",
      // duration: 1000,
    });

    form.reset();
  };

  useEffect(() => {
    // This logic now directly uses the userInfo object from the store
    if (userInfo && userInfo.role) {
      switch (userInfo.role.toLowerCase()) {
        case "farmer":
          navigate("/overview");
          break;
        case "supervisor":
          navigate("/supervisor/dashboard");
          break;
        case "admin":
          navigate("/admin");
          break;
        default:
          // Optional: handle unexpected roles or navigate to a default page
          break;
      }
    }
  }, [navigate, userInfo]); // Dependencies are correct
  const img: string[] = [cover1, cover3, cover4, cover5, cover6];
  // const toggleVisibility = () => setIsVisible(!isVisible);

  return (
    <div className="relative flex h-screen w-screen flex-row justify-between items-center dark:bg-black  overflow-hidden bg-gradient-to-r from-gray-50 via-blue-50 to-yellow-50">
      {/* Brand Logo */}
      {/* <div className="absolute left-2 top-5 lg:left-5"> */}
      {/*   <div className="flex items-center"> */}
      {/*     <p className="font-medium">Sila Green Genetics</p> */}
      {/*   </div> */}
      {/* </div> */}
      {/* Login Form */}
      <div className=" flex flex-col lg:container w-full items-center bg-transparent lg:w-1/2">
        <Card className={"lg:w-[450px] w-[450px] p-4"}>
          <div className=" lg:left-5">
            <div className="w-full flex flex-col gap-12 items-center justify-between">
              {/* <p className="font-medium">Sila Green Genetics</p> */}
              {/* <img alt="Logo" className="h-12 z-20 " src={logo} /> */}
            </div>
          </div>
          <div className="flex w-full max-w-sm flex-col items-center gap-4 p-4">
            <div className="w-full lg:text-left text-center">
              <p className="pb-2 text-xl font-medium">Welcome Back</p>
              <p className="text-small text-default-500">
                Log in to your account to continue
              </p>
            </div>

            {/* <div className="flex w-full flex-col gap-2"> */}
            {/*   <Button */}
            {/*     startContent={ */}
            {/*       <Icon icon="flat-color-icons:google" width={24} /> */}
            {/*     } */}
            {/*     variant="bordered" */}
            {/*   > */}
            {/*     Continue with Google */}
            {/*   </Button> */}
            {/* </div> */}

            <div className="flex w-full items-center gap-4 py-2">
              <Divider className="flex-1" />
            </div>

            <form
              className="flex w-full flex-col gap-3"
              onSubmit={form.handleSubmit(onSubmit)}
            >
              <Controller
                control={form.control}
                defaultValue=""
                name="email"
                render={({ field }) => (
                  <Input
                    {...field}
                    isClearable
                    isRequired
                    label="Email Address"
                    name="email"
                    placeholder="Enter your email"
                    type="email"
                    color={"success"}
                    variant="underlined"
                    classNames={{
                      label: "text-[#008c8fff]",
                    }}
                    onClear={() => form.resetField("email")}
                  />
                )}
              />

              <Controller
                control={form.control}
                defaultValue=""
                name="password"
                render={({ field }) => (
                  <Input
                    {...field}
                    isClearable
                    isRequired
                    autoComplete="current-password" // Use the correct
                    name="password"
                    type={"password"}
                    color={"success"}
                    label="Password"
                    placeholder="Enter your password"
                    // type={isVisible ? "text" : "password"}
                    variant="underlined"
                    className={"label:text-[#008c8fff]"}
                    onClear={() => form.resetField("password")}
                  />
                )}
              />
              <div className="flex items-center justify-end px-1 py-1">
                <Link
                  className="text-sm font-medium text-[#008c8fff] hover:underline"
                  href="/forgotPassword"
                  size="sm"
                >
                  Forgot password?
                </Link>
              </div>
              <Button
                className={"bg-[#008c8fff] text-white"}
                variant="shadow"
                isLoading={isPending}
                spinner={
                  form.formState.isSubmitting &&
                  isPending && (
                    <TailSpin
                      ariaLabel="tail-spin-loading"
                      color="#4fa94d"
                      height="80"
                      radius="1"
                      visible={true}
                      width="80"
                      wrapperClass=""
                      wrapperStyle={{}}
                    />
                  )
                }
                type="submit"
              >
                Log In
              </Button>
            </form>
            <p className="text-center text-[#008c8fff] text-small">
              Need to create an account?&nbsp;
              <Link href="/register" size="sm">
                Sign Up
              </Link>
            </p>
          </div>
        </Card>
      </div>

      {/* Right side */}
      <div className={"w-full hidden lg:block lg:w-1/2"}>
        <CarouselPlugin image={img} />
      </div>
    </div>
  );
}

export function CarouselPlugin({ image }: { image: string[] }) {
  return (
    <Carousel
      plugins={[
        Autoplay({
          delay: 10000,
          playOnInit: true,
          active: true,
          stopOnInteraction: false,
        }),
      ]}
      className=" w-full h-screen shadow-gray-800 shadow-lg "
    >
      <CarouselContent className={""}>
        {image.map((url, index: any) => (
          <CarouselItem
            key={index}
            className="w-full z-[-1] h-screen rounded-none"
          >
            <Image
              src={url}
              isBlurred
              isZoomed
              height="100vh"
              // width={""}
              alt={`Cover ${index + 1}`}
              className=" object-fit z-[-1] rounded-none bg-white/30 backdrop-blur-none"
            />

            {/* <div className="absolute w-full bottom-6 px-6 z-50 flex flex-col items-end justify-end gap-4 "> */}
            {/*   <User */}
            {/*     className="backdrop-blur-[20px]" */}
            {/*     avatarProps={{ */}
            {/*       src: "https://i.pravatar.cc/150?u=a04258a2462d826712d", */}
            {/*     }} */}
            {/*     classNames={{ */}
            {/*       base: "flex flex-row-reverse", */}
            {/*       name: "w-full text-right text-[#008c8fff]", */}
            {/*       description: "text-[#015354ff]", */}
            {/*     }} */}
            {/*     description="Founder & CEO at ACME" */}
            {/*     name="Bruno Reichert" */}
            {/*   /> */}
            {/*   <p className="w-full z-50 text-right text-2xl text-black backdrop-blur-[20px] rounded-2xl"> */}
            {/*     <span className="font-medium ">“</span> */}
            {/*     <span className="font-normal italic text-[#008c8fff]"> */}
            {/*       Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc */}
            {/*       eget augue nec massa volutpat aliquet. */}
            {/*     </span> */}
            {/*     <span className="font-medium">”</span> */}
            {/*   </p> */}
            {/* </div> */}
            {/* <div */}
            {/*   className="relative hidden h-screen w-screen flex-col-reverse rounded-medium mb-16 shadow -small lg:flex" */}
            {/*   style={{ */}
            {/*     backgroundImage: `url('${url}')`, */}
            {/*     backgroundSize: "fill", */}
            {/*     backgroundPosition: "center", */}
            {/*   }} */}
            {/* > */}
            {/*   <div className="flex flex-col items-end gap-4"> */}
            {/*     <User */}
            {/*       avatarProps={{ */}
            {/*         src: "https://i.pravatar.cc/150?u=a04258a2462d826712d", */}
            {/*       }} */}
            {/*       classNames={{ */}
            {/*         base: "flex flex-row-reverse", */}
            {/*         name: "w-full text-right text-black", */}
            {/*         description: "text-black/80", */}
            {/*       }} */}
            {/*       description="Founder & CEO at ACME" */}
            {/*       name="Bruno Reichert" */}
            {/*     /> */}
            {/*     <p className="w-full text-right text-2xl text-black/60"> */}
            {/*       <span className="font-medium">“</span> */}
            {/*       <span className="font-normal italic"> */}
            {/*         Lorem ipsum dolor sit amet, consectetur adipiscing elit. */}
            {/*         Nunc eget augue nec massa volutpat aliquet. */}
            {/*       </span> */}
            {/*       <span className="font-medium">”</span> */}
            {/*     </p> */}
            {/*   </div> */}
            {/* </div> */}
          </CarouselItem>
        ))}
      </CarouselContent>
      {/* <CarouselPrevious /> */}
      {/* <CarouselNext /> */}
    </Carousel>
  );
}
